/**
 * Canonical identifiers and store URLs for the SplitFiesta mobile app —
 * the SINGLE source of truth. Web (`apps/web`) and the API (`apps/api`)
 * both import from here; nothing should hardcode these URLs again.
 *
 * - iOS: App Store Connect app id (from `apps/mobile/eas.json`).
 * - Android: application id (from `apps/mobile/app.json`).
 */
export const IOS_APP_STORE_ID = '6773182927';
export const ANDROID_PACKAGE_NAME = 'com.splitfiesta.app';

export const APP_STORE_URLS = {
  ios: `https://apps.apple.com/app/id${IOS_APP_STORE_ID}`,
  android: `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_NAME}`,
} as const;

/**
 * Deep links straight into each store's review flow (the `itms-apps:` /
 * `market:` schemes open the store app rather than a browser). Each has an
 * https twin for devices where the store app can't take the scheme.
 */
export const APP_STORE_REVIEW_URLS = {
  ios: `itms-apps://apps.apple.com/app/id${IOS_APP_STORE_ID}?action=write-review`,
  android: `market://details?id=${ANDROID_PACKAGE_NAME}`,
} as const;

export const APP_STORE_REVIEW_FALLBACK_URLS = {
  ios: `${APP_STORE_URLS.ios}?action=write-review`,
  android: APP_STORE_URLS.android,
} as const;
